import * as Yup from 'yup';

export const initialValues = {
    knowledgeBaseRules: [{ value: '' }],
};

export const validationSchema = Yup.object().shape({
    knowledgeBaseRules: Yup.array().of(
        Yup.object().shape({
            value: Yup.string().required('Requerido'),
        })
    ),
});
